export const FONT = {
  INTER_16_BOLD: 'INTER_16_BOLD',
  INTER_14_BOLD: 'INTER_14_BOLD'
}

export const FALLBACK_CHAR_WIDTH = 15
